// Header.js
import React from 'react';
import watchHeader from '../../assets/watch-header.jpg';
import './Header.css';

const WatchHeader = () => {
  return (
    <div
      className="watch-headerc h-full bg-contain bg-right bg-no-repeat !px-9 !py-[50px]"
      style={{ backgroundImage: `url(${watchHeader})` }}
    >
      <div className="purple-circle"></div>
      {/* <div className="purple-ellipse"></div> */}
      <div className="header-content">
        <div className="header-text">
          <h1>Watch Races</h1>
          {/* <p>Watch your live race and track token</p>
          <p>performance here.</p> */}
        </div>
        {/* <div className="watch-header-image">
          <img src={watchHeader} alt="Race Wizard" width={250} />
        </div> */}
      </div>
    </div>
  );
};

export default WatchHeader;
